import { Ref, useEffect } from 'react'
import {
  DesktopModalWrapper,
  Container
} from '@smuchile/pkg-unimarc-components'
import {
  getBemId,
  getGlobalStyle
} from '@smuchile/pkg-unimarc-components/helpers'
import { ModalButton } from '../ModalButton'
import { ModalBody } from '../ModalBody'
import { IUsualsAndFavoritesData } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IGetMyUsualsAndFavorites'
import { sleep } from '@smuchile/pkg-unimarc-hooks'
import { ICart } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/INewCartUnimarc'
import styles from '../MyUsualsAndFavoritesWrapper.module.css'

export interface ModalProps {
  contentRef: Ref<unknown>
  failedData: ICart
  favorites: IUsualsAndFavoritesData
  isLoadingOrderForm: boolean
  myUsuals: IUsualsAndFavoritesData
  handleClick: () => void
  handleClose: () => void
  handleCloseNoStockToast: () => void
  scrollToTopOnContent: () => void
}

export const ModalDesktop = ({
  contentRef,
  failedData,
  favorites,
  isLoadingOrderForm,
  myUsuals,
  handleClick,
  handleClose,
  handleCloseNoStockToast,
  scrollToTopOnContent
}: ModalProps): React.ReactElement => {
  const modal = document.getElementById('myUsualsAndFavoritesModal__container')

  const onClose = async () => {
    if (modal) {
      modal.classList.remove(styles.openModal)
      modal.classList.add(styles.closeModal)
      await sleep(200)
    }
    handleClose()
  }

  useEffect(() => {
    if (modal) {
      modal.classList.add(styles.openModal)
      modal.classList.remove(styles.closeModal)
    }
  }, [modal])

  return (
    <DesktopModalWrapper
      blockId={getBemId('myUsualsAndFavoritesModal', 'header')}
      bodyChildrenProps={{
        maxHeight: 'none',
        overflow: 'auto',
        padding: '0'
      }}
      borderEdge='none'
      footerChildrenProps={{
        boxShadow: '0',
        default: false,
        children: (
          <Container
            customClassName={styles.customBorderTop}
            justifyContent='center'
            padding='16px 32px'
          >
            <ModalButton
              handleOnClick={handleClick}
              isLoadingOrderForm={isLoadingOrderForm}
              minWidth='406px'
            />
          </Container>
        ),
        height: 72,
        padding: '0',
        bottom: '0'
      }}
      headerCloseIcon={{
        name: 'CloseThin',
        customSize: 20,
        default: true
      }}
      headerContainerProps={{
        minHeight: '68px'
      }}
      headerCustomClass={styles.customHeader}
      headerTitle='¡Qué no se te olviden!'
      headerTitleProps={{
        fontWeight: 'semibold',
        default: true
      }}
      modalConfigsProps={{
        containerId: getBemId('myUsualsAndFavoritesModal', 'container'),
        customContainerClassName: styles.modalContainer,
        isOpen: true,
        minHeight: '100vh',
        maxWidth: '656px',
        isWindowBlocked: true,
        toggle: onClose,
        toggleOutside: onClose
      }}
      ref={contentRef}
      styleProps={{
        borderRadius: getGlobalStyle('--border-radius-none'),
        customHeightModalContent: '100%'
      }}
    >
      <ModalBody
        failedData={failedData}
        favorites={favorites}
        handleCloseNoStockToast={handleCloseNoStockToast}
        isLoadingOrderForm={isLoadingOrderForm}
        myUsuals={myUsuals}
        onClose={onClose}
        scrollToTopOnContent={scrollToTopOnContent}
      />
    </DesktopModalWrapper>
  )
}
